// extracted by mini-css-extract-plugin
export var icon = "_59-1";
export var subtext = "_59-0";